module.exports = __webpack_public_path__ + "static/media/msl_double_4-3.b61311d5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/msl_double_4-3.jpg
// module id = 75
// module chunks = 0